// src/components/LoadingScreen.ts
export function LoadingScreen(opts: { onDone: () => void }): HTMLElement {
  const el = document.createElement('div');
  el.className = 'panel loading-screen';
  el.innerHTML = `
    <div class="panel__head">
      <div class="kicker">Inicializando portal</div>
      <div class="h1"><span>AETHERIA</span></div>
      <div class="subtitle">Tejiendo el velo entre mundos…</div>
    </div>
    <div class="panel__body">
      <div class="logo-wrap">
        <div class="logo-orb" aria-hidden="true"><div class="logo-orb__core"></div></div>
      </div>
      <div class="progress" aria-label="Progreso de carga" style="margin-top:1rem">
        <div class="progress__bar" id="aetheria-progress"></div>
      </div>
      <div class="loading-meta"><span class="pulse" aria-hidden="true"></span><span id="aetheria-loading-text">Sincronizando Aetheria</span><span id="aetheria-loading-pct" style="color:var(--text);margin-left:.25rem">0%</span></div>
      <p style="margin-top:.9rem;color:var(--muted);font-size:.82rem;line-height:1.6">
        Fase 1 — Base jugable. Sin combate ni captura aún. Solo el umbral del mundo.
      </p>
    </div>
  `;

  const bar = el.querySelector<HTMLDivElement>('#aetheria-progress')!;
  const pctEl = el.querySelector<HTMLSpanElement>('#aetheria-loading-pct')!;
  const textEl = el.querySelector<HTMLSpanElement>('#aetheria-loading-text')!;

  const phases = [
    'Sincronizando Aetheria',
    'Cartografiando islas flotantes',
    'Despertando Asterias',
    'Abriendo el portal'
  ];

  let p = 0;
  const timer = window.setInterval(() => {
    // crecimiento no lineal para sensación real
    const increment = p < 60 ? 8 + Math.random() * 10 : p < 85 ? 4 + Math.random() * 6 : 1 + Math.random() * 3;
    p = Math.min(100, p + increment);
    bar.style.width = `${p}%`;
    pctEl.textContent = `${Math.floor(p)}%`;
    const phaseIdx = Math.min(phases.length - 1, Math.floor((p / 100) * phases.length));
    textEl.textContent = phases[phaseIdx];
    if (p >= 100) {
      window.clearInterval(timer);
      window.setTimeout(() => opts.onDone(), 380);
    }
  }, 120);

  return el;
}
